import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { t } from "i18next";
import { Badge } from "components/badge/Badge";
import "./bankAccountDisplay.scss";
import { uppercase } from "helpers/Helpers";

export interface IBankAccountDisplayProps {
  accountNumber: string;
  currency: string;
  bankAccountName?: string;
  bankAccountId?: number;
  isDefault?: boolean;
  manage?: boolean;
  onRemove?: () => void;
}

export default function BankAccountDisplay(props: IBankAccountDisplayProps) {
  const { accountNumber, currency, bankAccountName, isDefault, manage, bankAccountId, onRemove } = props;

  function handleManageClick() {
    if (bankAccountId === undefined || bankAccountId === null) {
      return;
    }

    window.open(`/admin/settings/bank_accounts/${String(bankAccountId)}`, "_blank");
  }

  return (
    <div className="tee-on-payments-added-account-container">
      <div className="tee-on-payments-added-account-bank-content">
        <div className="tee-on-payments-added-account-bank">
          <FontAwesomeIcon icon={["far", "building-columns"]} />
        </div>

        <div>
          <p>{bankAccountName ?? t("Bank Name")}</p>
          <p>**** **** {accountNumber.slice(-4)}</p>
        </div>

        <div className="flex gap-3 items-center">
          <span>
            {isDefault && (
              <Badge size="medium" type={"gray"}>
                {"Default"}
              </Badge>
            )}
          </span>

          <span>
            <hr className="tee-on-payments-added-account-meta-separator" />
          </span>

          <div className="flex gap-3 items-center">
            <img
              width="20"
              height="20"
              src={currency.toUpperCase() === "CAD" ? "/public/images/flags/ca.svg" : currency.toUpperCase() === "USD" ? "/public/images/flags/us.svg" : ""}
              alt=""
            />
            <span>{uppercase(currency)}</span>
          </div>
        </div>
      </div>

      {(manage || onRemove) && (
        <div className="flex gap-2 items-center shrink-0">
          {manage && (
            <button
              type="button"
              className="flex items-center gap-3 text-sm text-semibold text-gray-900"
              onClick={handleManageClick}
            >
              {t("Manage")}
              <img src="/public/images/icons/externalLink.svg" alt="externalLink.svg" />
            </button>
          )}
          {onRemove && (
            <button
              type="button"
              className="tee-on-payments-added-account-remove"
              onClick={onRemove}
              aria-label={t("Remove bank account")}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}
